import { contextFactory } from '@frontend/design-system';

export interface FieldConditionContextValue {
  conditionId: string;
  conditionIndex: number;
}

export const [FieldConditionContext, useFieldConditionContext] = contextFactory<FieldConditionContextValue>();
